module.exports = __webpack_public_path__ + "static/media/newspaper.bb7a6084.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newspaper.jpg
// module id = 277
// module chunks = 0